<template>
	<div class="MyCart">
		<!-- pc页头 -->
		<TopHeader v-if="isPc" />
		<!-- mobile title -->
		<div class="topPart" v-else>
			<div class="return" @click="backPageFn"></div>
			<a href="https://m.tunnelling.cn/Manager/MemberIndex.aspx" v-if="isshowHeader"><img :src="imgUrl" /></a>
		</div>
		<!-- 购物车容器 pc端 -->
		<div class="pc-cart-container" v-if="isPc">
			<!-- 购物车商品数量 -->
			<div class="cart-count">
				{{ `购物车（全部${cartNum}）` }}
			</div>
			<!-- 购物车商品 -->
			<div v-if="goodsData.length">
				<div class="cart-goods">
					<!-- title -->
					<div class="check-all-box c-box-flex">
						<div class="all-checkbox c-box-flex c-wid-flex">
							<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
							<div class="goods-text c-small-text">商品</div>
						</div>
						<div class="Price c-small-text c-wid-124">价格</div>
						<div class="handle c-small-text c-wid-124">操作</div>
					</div>
					<!-- goods -->
					<div class="goods-group-box">
						<div class="goods-item-box" v-for="(item, index) in goodsData" :key="index">
							<!-- 多选框 -->
							<div class="item-check"><el-checkbox v-model="item.checked" :indeterminate="item.isIndeterminate" @change="handleCheckItemsChange(item, $event)"></el-checkbox></div>
							<!-- 商品信息 -->
							<div class="item-info">
								<div class="group-box">
									<!-- 封面图片 -->
									<router-link :to="{path:'/bookDetail', query:{InformationId:item.informationId}}" target="_blank" class="img-box">
										<img :src="item.informationImagePath" :onerror="defaultImg" />
									</router-link>
									<!-- 书的信息 -->
									<div class="c-wid-flex">
										<!-- 书及其实际价格 -->
										<div class="price-box c-box-flex">
											<router-link :to="{path:'/bookDetail', query:{InformationId:item.informationId}}" target="_blank" class="title c-wid-flex">{{ item.informationTitle }}</router-link>
											<div class="check-num c-wid-124" v-if="item.items.length">{{ `已选 ${item.checkNum} 项` }}</div>
											<div class="actual-price c-wid-124"><span v-if="item.items.length" class="text">共</span><span>{{ `¥${Math.floor(item.actualPrice * 100) / 100}` }}</span></div>
											<div class="c-small-text delete-txt c-wid-124" @click="deleteGoodsFn('all', item, index)">删除</div>
										</div>
										<!-- 购买类型及已减价格 {{ item.buyType }} -->
										<div class="buy-type-box c-box-flex">
											<div class="buy-type c-wid-flex"></div>
											<div class="c-reduced-price c-wid-124"><span v-if="item.hasBeenReduced">{{ `(已减¥${Math.floor(item.hasBeenReduced * 100) / 100})` }}</span></div>
											<div class="c-small-text c-wid-124"></div>
										</div>
									</div>
								</div>
								<!-- 书的章节及其价格 -->
								<div v-if="item.items.length" class="chapter-box">
									<div class="chapters c-box-flex" v-for="(it, ind) in item.items" :key="ind">
										<div class="check-box"><el-checkbox v-model="it.checked" @change="handleCheckChange(item, ind, $event)"></el-checkbox></div>
										<div class="title c-wid-flex">{{ it.informationContentTitle }}</div>
										<div class="price c-wid-124">{{ `¥${it.price}` }}</div>
										<div class="handle-btn c-small-text c-wid-124" @click="deleteGoodsFn('one', it.goodsId, index, ind)">删除</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 商品的总和 -->
				<div class="cart-handle c-box-flex">
					<!-- 全选删除 -->
					<div class="all-checkbox c-box-flex c-wid-flex">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
						<div class="goods-text c-small-text" @click="deleteAllBtnFn">删除</div>
					</div>
					<!-- 合计 -->
					<div class="total-box">
						<span>合计</span>
						<div class="total-price">
							<div class="price">{{ `¥${totalPrice}` }}</div>
							<div class="c-reduced-price" v-if="reducedPrice"><span>{{ `(共减¥${reducedPrice})` }}</span></div>
						</div>
					</div>
					<!-- 立即下单 -->
					<div class="order-now-btn" @click="orderNowFn">立即下单</div>
				</div>
			</div>
			<!-- 暂无商品 -->
			<div class="nothing-box" v-else>
				<el-empty description="挑点喜欢的装进购物车">
					<router-link to="/index">去书库</router-link>
				</el-empty>
			</div>
		</div>
		<!-- 购物车容器 移动端样式 -->
		<div class="mobile-cart-container" v-else>
			<!-- 购物车商品数量 -->
			<div class="cart-count">
				{{ `购物车(${cartNum})` }}
			</div>
			<!-- 购物车商品 -->
			<div class="cart-goods" v-if="goodsData.length">
				<!-- goods -->
				<div class="goods-group-box">
					<div class="check-goods-box" v-for="(item, index) in goodsData" :key="index">
						<div class="goods-box">
							<el-checkbox v-model="item.checked" :indeterminate="item.isIndeterminate" @change="handleCheckItemsChange(item, $event)"></el-checkbox>
							<div class="group-box">
								<!-- 封面图片 -->
								<router-link :to="{path:'/bookDetail', query:{InformationId:item.informationId}}" class="img-box">
									<img :src="item.informationImagePath" :onerror="defaultImg" />
								</router-link>
								<!-- 书的信息 -->
								<div class="info-box c-wid-flex">
									<!-- 书名 -->
									<div class="book-name-box c-box-flex">
										<router-link :to="{path:'/bookDetail', query:{InformationId:item.informationId}}" class="name">{{ item.informationTitle }}</router-link>
										<div class="delete c-small-text" @click.prevent="deleteGoodsFn('all', item, index)">删除</div>
									</div>
									<!-- 已选项数 -->
									<div class="check-num-box">
										<span>{{ `已选 ${item.checkNum} 项` }}</span>
									</div>
									<!-- 购买类型及已减价格(弃用) -->
									<!-- <div class="buy-type-box">
										章节购买
										<div class="type-chapter" v-if="item.items.length" @click="item.showChapter = !item.showChapter">
											<span>{{ item.buyType }}</span><i class="el-icon-arrow-down icon-arrow" :class="{'icon-arrow-rotate': item.showChapter}"></i>
										</div>
										全书购买
										<div class="type-all" v-else>{{ item.buyType }}</div>
									</div> -->
									<!-- 商品合计 -->
									<div class="goods-total-box c-box-flex">
										<div class="actual-pric"><span v-if="item.items.length" class="text">共</span><span>{{ `¥${Math.floor(item.actualPrice * 100) / 100}` }}</span></div>
										<div class="c-reduced-price" v-if="item.hasBeenReduced"><span>{{ `(已减¥${Math.floor(item.hasBeenReduced * 100) / 100})` }}</span></div>
									</div>
								</div>
							</div>
						</div>
						<!-- 书的章节及其价格 -->
						<div v-if="item.items.length" class="chapter-box">
							<div class="chapters c-box-flex" v-for="(it, ind) in item.items" :key="ind">
								<div class="check-box"><el-checkbox v-model="it.checked" @change="handleCheckChange(item, ind, $event)"></el-checkbox></div>
								<div class="info-box c-wid-flex c-box-flex">
									<div class="title c-wid-flex">{{ it.informationContentTitle }}</div>
									<div class="price">{{ `¥${it.price}` }}</div>
									<div class="handle-btn c-small-text" @click.prevent="deleteGoodsFn('one', it.goodsId, index, ind)">删除</div>
								</div>
							</div>
							<!-- 带有展开收起功能(弃用) -->
							<!-- <el-collapse-transition>
								<div v-show="item.showChapter">
									<div class="chapters c-box-flex" v-for="(it, ind) in item.items" :key="ind">
										<div class="title c-wid-flex">{{ it.informationContentTitle }}</div>
										<div class="price">{{ `¥${it.price}` }}</div>
										<div class="handle-btn c-small-text" @click.prevent="deleteGoodsFn('one', it.goodsId, index)">删除</div>
									</div>
								</div>
							</el-collapse-transition> -->
						</div>
					</div>
				</div>
				<!-- 商品的总和 -->
				<div class="cart-handle c-box-flex">
					<!-- 全选删除 -->
					<div class="all-checkbox c-box-flex">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
						<div class="handle-delete c-small-text" @click="deleteAllBtnFn">删除</div>
					</div>
					<div class="total-price-box c-box-flex c-wid-flex">
						<!-- 合计 -->
						<div class="total-box">
							<span class="text">合计：</span>
							<span class="price">{{ `¥${totalPrice}` }}</span>
						</div>
						<!-- 结算 -->
						<div class="order-now-btn" @click="orderNowFn">结算</div>
					</div>
				</div>
			</div>
			<!-- 暂无商品 -->
			<div class="nothing-box" v-else>
				<el-empty description="挑点喜欢的装进购物车">
					<router-link to="/index">去书库</router-link>
				</el-empty>
			</div>
		</div>
		<!-- 页脚 -->
		<BottomFooter />
	</div>
</template>

<script>
	import common from '../../assets/js/common.js'
	import TopHeader from '../../components/TopHeader.vue'
	import BottomFooter from '@/components/BottomFooter.vue'
	export default {
		name: 'MyCart',
		data() {
			return {
				goodsData: [],
				cartNum: 0,  // 购物车数量
				isNoAllChecked: false,  // 全选时是否有未勾选的子项
				checkAll: false,  // 是否全选
				isIndeterminate: false,  // 控制全选的样式
				checkedGoods: [],  // 已选择的goods
				totalPrice: 0,  // 合计
				reducedPrice: 0,  // 共减的钱数
				isPc: true,
				imgUrl: '',  // 头像url
				isshowHeader: true,  // 是否显示头像
				defaultImg: 'this.src="' + require('../../assets/img/default_pic.png') + '"'  // 默认封面
			}
		},
		created() {
			// 判断加载哪个dom
			let wid = window.innerWidth;
			if (wid >= 320 && wid <= 1024) {
				this.isPc = false;
			}
		},
		mounted() {
			this.GetUserInfo()
			this.getGoodsList()
		},
		components: {
			TopHeader,
			BottomFooter
		},
		methods: {
			// 获取购物列表
			getGoodsList() {
				this.$fetch('/api/ShoppingCarts')
					.then((res) => {
						// 判断会员是否登录
						if(res.data && res.data.accessAllowed === false) {
							this.LoginTip();
							return
						}
						
						// 增加所需字段
						res.data.forEach(item => {
							this.$set(item, 'checked', false);
							this.$set(item, 'isIndeterminate', false);
							this.$set(item, 'checkNum', 0);
							item.items.forEach(child => {
								this.$set(child, 'checked', false);
							})
						});
						
						this.goodsData = res.data;
					}).catch((err) => {
						throw err;
					});
			},
			// 获取用户信息
			GetUserInfo(){
				this.$fetch('/Login')
				.then((res)=>{
					if(res.data.accessAllowed === false){
						this.isshowHeader = false;
						return;
					}
					this.imgUrl = res.data.imagePath;
					// 获取购物车数量
					this.getCartNumFn();
				}).catch((err)=>{
					throw err;
				});
			},
			// 获取购物车数量
			getCartNumFn() {
				this.$fetch('/api/ShoppingCarts/count').then(res => {
					this.cartNum = res.data.count
				}).catch(err => {
					throw err;
				})
			},
			// 未登录提示
			LoginTip() {
			    this.$confirm('登录状态失效，需重新登录，是否继续？', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(() => {
			        let nowHref = location.href;
			        let href = 'https://www.tunnelling.cn/PMember/MemberLogin.aspx?returnUrl=' + encodeURIComponent(nowHref);
			        location.href = href;
			    }).catch(() => {});
			},
			// 立即下单
			orderNowFn() {
				// 获取所选商品
				let checkedGoods = []
				this.goodsData.forEach(item => {
					if(item.checked) {
						item.orderItems = item.items
						checkedGoods.push(item)
					}else if(item.isIndeterminate) {
						item.orderItems = []
						item.items.forEach(child => {
							if(child.checked) {
								item.orderItems.push(child)
							}
						})
						checkedGoods.push(item)
					}
				});
				// 未选择商品提示
				if(!checkedGoods.length) {
					this.$message({
						message: '请先选择商品再下单',
						type: 'warning'
					});
					return
				}
				// 判断登陆状态
				this.$fetch('/Login')
				    .then((res) => {
				        // 未登录 提示用户
						if (res.data.accessAllowed === false) {
				            this.LoginTip();
				            return;
				        }
						
						// 跳转到订单详情页面
						this.toOrderDetailsFn(checkedGoods)
				    }).catch((err) => {
				        throw err;
				    });
			},
			// 跳转到订单确认页面
			toOrderDetailsFn(checkedGoods) {
				let goodsPrams = {
					'totalPrice': this.totalPrice,
					'goods': checkedGoods
				}
				sessionStorage.setItem('zhishi_OrderGoods',JSON.stringify(goodsPrams))
				this.$router.push({
					name: 'ConfirmOrder'
				})
			},
			// 全部删除btn
			deleteAllBtnFn() {
				let ids = []
				this.goodsData.forEach(item => {
					if(item.checked && item.goodsId) {
						ids.push(item.goodsId)
					}
					item.items.forEach(child => {
						if(child.checked) {
							ids.push(child.goodsId)
						}
					})
					// 有未勾选的子项
					if(item.isIndeterminate) {
						this.isNoAllChecked = true
					}
				});
				this.deleteGoodsFn('allDetele', ids)
			},
			// 删除某个商品
			deleteGoodsFn(type, ids, index, ind) {
				// 删除整个商品所需的id
				let allIds = []
				if(type === 'all') {
					if(ids.goodsId) {
						allIds.push(ids.goodsId)
					}else {
						ids.items.forEach(it => {
							allIds.push(it.goodsId)
						})
					}
				}
				// 删除需要传的id数组
				let deleteIds = type === 'all' ? allIds : (type === 'allDetele' ? ids : [ids]);
				// 当前所删的商品
				let nowDeleteGoods = this.goodsData[index]
				
				this.$Del('/api/ShoppingCarts', {
					'data': deleteIds
				}).then(res => {
					// 未登录 提示用户
					if (res.data && res.data.accessAllowed === false) {
					    this.LoginTip();
					    return;
					}
					
					// 将此商品从数组里删除
					if(type === 'all') {
						this.goodsData.splice(index, 1)
						// 计算合计
						this.calculateTotalPrice();
					}else if(type === 'one'){
						// 只有一个章节时 把此商品删除；否则只删除某一个章节；(items.length为1 代表该商品肯定是章节)
						if(nowDeleteGoods.items.length === 1) {
							this.goodsData.splice(index, 1)
						}else {
							// 当此商品有选中的章节时，才执行--
							if((nowDeleteGoods.checked || nowDeleteGoods.isIndeterminate) && nowDeleteGoods.items[ind].checked) {
								nowDeleteGoods.checkNum --
							}
							// 删的为书时 hasBook需赋值为false
							if(nowDeleteGoods.items[ind].isBook) {
								nowDeleteGoods.hasBook = false
							}else {
								
							}
							
							nowDeleteGoods.items.splice(ind, 1)
							nowDeleteGoods.checked = nowDeleteGoods.checkNum === nowDeleteGoods.items.length
							nowDeleteGoods.isIndeterminate = nowDeleteGoods.checkNum > 0 && nowDeleteGoods.checkNum < nowDeleteGoods.items.length
						}
						
						// 计算合计
						this.calculateTotalPrice();
					}else {
						// 全部删除时
						this.totalPrice = 0
						this.reducedPrice = 0
						this.checkAll = false
						this.isIndeterminate = false
						// 代表有未勾选的子项
						if(this.isNoAllChecked) {
							this.getGoodsList()
						}else {
							this.goodsData = []
						}
					}
					
					// 删除成功提示
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					
					// 获取购物车数量
					common.$emit('getCartNum')
					this.getCartNumFn();
				}).catch(err => {
					throw err
				})
			},
			// 全选checkbox
			handleCheckAllChange(val) {
				this.handlerCheckAll(val)
				this.isIndeterminate = false;
			},
			// 全选or全不选做的操作
			handlerCheckAll(isChecked) {
				// 合计|共减|是否包含某商品含有章节及全书购买的情况
				let actual = 0, reduced = 0, isHasBook = false;
				
				this.goodsData.forEach(item => {
					item.checked = isChecked
					// 清零
					if(item.items.length) {
						item.checkNum = 0
						item.actualPrice = 0
						item.hasBeenReduced = 0
					}
					item.items.forEach(child => {
						if(isChecked) {
							// 某商品含有章节及全书购买的情况下 点击全选，默认勾选所有章节，不勾选全书购买这一项
							child.checked = child.isBook ? false : true
							item.isIndeterminate = item.hasBook
							if(!child.isBook) {
								item.actualPrice += child.price
								item.hasBeenReduced += child.hasBeenReduced
							}else if(child.isBook && item.items.length > 1){
								isHasBook = true
							}
							// 已勾选的数量
							if(child.checked) ++item.checkNum
						}else {
							child.checked = isChecked
						}
					})
					// 计算合计
					if(isChecked) {
						actual += item.actualPrice
						reduced += item.hasBeenReduced
					}else {
						item.actualPrice = item.items.length ? 0 : item.actualPrice
						item.hasBeenReduced = item.items.length ? 0 : item.hasBeenReduced
						item.checkNum = 0
						item.isIndeterminate = false
					}
				});
				// 合计赋值
				this.totalPrice = Math.floor(actual * 100) / 100
				this.reducedPrice = reduced
				// 提示(某商品含有章节及全书购买的情况)
				if(isHasBook) {
					this.$message({
						message: '部分书包含“全书购买”及相关章节，系统为您默认选择所有章节，要购买整书请直接勾选“全书购买”。',
						type: 'warning',
						offset: 100
					});
				}
			},
			// 商品勾选
			handleCheckItemsChange(item, $event) {
				// 此判断针对于商品包含全书及章节，为了使之于全是章节的勾选逻辑相同
				// !item.checkNum && item.hasBook && item.items.length 解决全选章节后，再逐个取消勾选，$event此时返回的false，实际应该为true
				// !$event && item.isIndeterminate && item.hasBook 解决isIndeterminate为true，再点击会取消全选
				if(!$event && item.isIndeterminate && item.hasBook || !item.checkNum && item.hasBook && item.items.length) {
					$event = true
				}
				// 勾选
				if($event) {
					// 如果勾选的包含商品包含全书及章节，需提示及全选章节(默认只勾选所有章节，而不勾选全书) item.items.length：0-代表是全书购买 >0-代表章节or章节及全书购买
					if(item.items.length) {
						// 判断是否存在商品包含全书及章节的情况
						if(item.hasBook) {
							// 判断长度 是为了防止用户执行了删除操作，以至于不会存在商品包含全书及章节的情况
							if(item.items.length > 1) {
								this.$message({
									message: '该书包含“全书购买”及相关章节，系统为您默认选择所有章节，要购买整书请直接勾选“全书购买”。',
									type: 'warning',
									offset: 100
								});
								item.isIndeterminate = true
								item.checkNum = item.items.length - 1
								item.checked = false
								// 默认选择全部章节
								item.items.forEach((it) => {
									if(it.isBook) {
										it.checked = false
									}else {
										it.checked = true
									}
								})
							}else {
								item.isIndeterminate = false
								item.checkNum = 1
								item.checked = true
								item.items[0].checked = true
							}
							
							
						}else {
							// 只含有多个章节的情况
							item.isIndeterminate = false
							item.checkNum = item.items.length
							item.checked = true
							item.items.forEach((it) => {
								it.checked = true
							})
						}
					}else {
						// 整书购买 直接勾选
						item.checked = true
					}
				}else {
					// 取消勾选
					item.isIndeterminate = false
					item.items.forEach((it) => {
						it.checked = false
					})
					item.checked = false
					item.checkNum = 0
				}
				
				// 计算合计
				this.calculateTotalPrice()
			},
			// 单个章节勾选
			handleCheckChange(item, ind, $event) {
				// isCheckAll：勾选框样式；isBook：是否存在全书购买勾选；isChapter：是否存在章节勾选
				let isCheckAll = true, isBook = false, isChapter = false
				
				if($event) {
					// 判断之前勾选的类型(书or章节)
					item.items.forEach((it) => {
						if(it.isBook && it.checked) {
							isBook = true
						}else if(!it.isBook && it.checked) {
							isChapter = true
						}
					})
					
					// 存在全书与章节同时勾选的情况
					if(isBook && isChapter) {
						// 当前勾选的为全书购买
						if(item.items[ind].isBook) {
							// 取消其他勾选的章节
							item.items.forEach((it) => {
								if(!it.isBook) it.checked = false
							})
							// tip
							this.$message({
								message: '由于选择了此书的全书购买，已为您取消相关章节的选择。',
								type: 'warning',
								offset: 100
							});
						}else {
							// 当前勾选的为章节，取消勾选的全书购买
							item.items.forEach((it) => {
								if(it.isBook) {
									it.checked = false
								}
							})
							// tip
							this.$message({
								message: '由于单独选择了此书的章节，已为您取消全书购买的选择。',
								type: 'warning',
								offset: 100
							});
						}
						// 都会存在有未勾选的情况
						isCheckAll = false
						// 勾选项为1
						item.checkNum = 1
						// 勾选
						item.items[ind].checked = true
					}else {
						// 当前及之前所勾选的都是章节
						// 已选项清0，以免已选项相加时，将之前所计算的已选项的总和也加进去
						item.checkNum = 0
						// 当前勾选的为全书购买(表示该商品没有勾选过单个章节)
						if(item.items[ind].isBook) {
							isCheckAll = false
							item.checkNum = 1
						}else {
							// 计算所选章节的合计
							item.items.forEach((it) => {
								if(it.checked) {
									item.checkNum ++
								}else {
									isCheckAll = false
								}
							})
						}
					}
				}else {
					// 已选项清0，以免已选项相加时，将之前所计算的已选项的总和也加进去
					item.checkNum = 0
					// 计算所有勾选的价格
					item.items.forEach((it) => {
						if(it.checked) {
							item.checkNum ++
						}else {
							isCheckAll = false
						}
					})
				}
				// 勾选框样式
				item.checked = item.checkNum === item.items.length
				item.isIndeterminate = item.checkNum > 0 && item.checkNum < item.items.length
				// 计算合计
				this.calculateTotalPrice()
			},
			// 计算总价及判断是否全选
			calculateTotalPrice() {
				let actual = 0, reduced = 0, isCheckNum = 0, isIndeterminate = false
				// 循环遍历
				this.goodsData.forEach(item => {
					// 清零
					if(item.items.length) {
						item.actualPrice = 0
						item.hasBeenReduced = 0
					}
					
					item.items.forEach(child => {
						if(child.checked) {
							item.actualPrice += child.price
							item.hasBeenReduced += child.hasBeenReduced
						}
					})
					// 价格相加
					if(item.checked || item.isIndeterminate) {
						actual += item.actualPrice
						reduced += item.hasBeenReduced
					}
					// 勾选数
					if(item.checked) {
						isCheckNum ++
					}
					// 判读是否有未全选的
					if(item.isIndeterminate) {
						isIndeterminate = true
					}
				});
				// 合计赋值
				this.totalPrice = Math.floor(actual * 100) / 100
				this.reducedPrice = reduced
				// console.log('合计', this.totalPrice, this.reducedPrice)
				// 全选的样式
				this.checkAll = isCheckNum === this.goodsData.length
				this.isIndeterminate = isIndeterminate || (isCheckNum > 0 && isCheckNum < this.goodsData.length)
			},
			// 页面返回
			backPageFn() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped>
	/* 移动端 */
	@media screen and (min-width: 320px) and (max-width: 1024px) {
		.mobile-cart-container {
			background-color: #F8F8F8;
			padding-bottom: 1.24rem;
		}
		
		/* 暂无商品 */
		.nothing-box a {
			display: block;
			width: 162px;
			line-height: 40px;
			background: #2468F2;
			border-radius: 4px;
			font-size: 14px;
			color: #FFFFFF;
			letter-spacing: 0;
			margin-bottom: 93px;
			text-align: center;
		}
		
		/* 返回 */
		.topPart{
			width: 100%;
			height: .88rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 .24rem;
		}
		
		.topPart img{
			width: .6rem;
			height: .6rem;
			border-radius: 50%;
		}
		
		.topPart .return{
			width: .4rem;
			height: .4rem;
			background: url(../../assets/img/return_mobile.svg) no-repeat;
			background-size: 100% 100%;
		}
		
		/* 购物车数量 */
		.mobile-cart-container .cart-count {
			padding: .2rem;
			font-size: .36rem;
			font-weight: 500;
			color: #333333;
			background-color: #FFFFFF;
		}
		
		/* 商品列表 */
		.cart-goods {
			padding: .24rem .2rem;
		}
		
		.check-goods-box {
			background-color: #FFFFFF;
			padding: .2rem;
			margin-bottom: .2rem;
		}
		
		.goods-group-box .goods-box {
			display: flex;
			align-items: center;
		}
		
		.group-box {
			width: calc(100% - 32px);
			display: flex;
			margin-left: .2rem;
		}
		
		/* 书的封面 */
		.group-box .img-box{
			display: block;
			width: 1.4rem;
			height: 1.88rem;
			margin-right: .16rem;
		}
		
		.group-box .img-box img {
			width: 100%;
			height: 100%;
		}
		
		/* 书的信息 */
		.info-box {
			width: calc(100% - 1.56rem);
		}
		
		/* 书名 */
		.book-name-box .name {
			width: calc(100% - 0.7rem);
			font-size: .32rem;
			font-weight: 500;
			color: #333333;
			overflow:hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow:ellipsis;
		}
		
		.book-name-box .delete {
			flex: 1;
			text-align: right;
		}
		
		/* 已选项数 */
		.check-num-box {
			margin: 0.3rem 0 0.22rem;
			font-size: 14px;
			min-height: 14px;
			font-weight: 400;
			color: #333333;
		}
		
		/* 购买方式 */
		.buy-type-box {
			margin: .12rem 0 .5rem;
		}
		
		.buy-type-box .type-chapter {
			width: 1.68rem;
			height: .48rem;
			line-height: .48rem;
			text-align: center;
			background: #3A69E9;
			border-radius: .04rem;
			color: #FFFFFF;
			font-weight: 400;
			font-size: .28rem;
		}
		
		.buy-type-box .type-chapter>span {
			margin-right: .08rem;
		}
		
		.buy-type-box .type-all {
			width: 1.36rem;
			height: .48rem;
			line-height: .48rem;
			text-align: center;
			background: #F0F0F0;
			border-radius: .04rem;
		}
		
		.icon-arrow {
			/*设置所有动画的效果：0.3s 淡出效果*/
			transition: all .3s ease-out;
		}
		
		.icon-arrow-rotate {
		    /*旋转180度*/
		    transform: rotate(180deg);
		}
		
		/* 章节 */
		.chapter-box .chapters {
			font-size: .28rem;
			font-weight: 400;
			color: #333333;
		}
		
		.chapter-box .chapters .info-box {
			margin-left: .1rem;
			border-bottom: 1px solid #EFEFEF;
			padding: .2rem 0;
		}
		
		.chapter-box .title {
			font-size: .28rem;
			font-weight: 400;
			color: #3A3A3A;
			overflow:hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow:ellipsis;
		}
		
		.chapter-box .price {
			margin: 0 .5rem 0 .3rem;
		}
		
		/* 商品合计 */
		.goods-total-box .actual-pric {
			font-size: .36rem;
			font-weight: 600;
			color: #FC6B21;
			margin-right: .2rem;
		}
		
		.goods-total-box .actual-pric .text {
			font-size: 14px;
			font-weight: 400;
			color: #333333;
			margin-right: 8px;
		}
		
		/* 商品总和 */
		.cart-handle {
			width: 100%;
			height: 1.24rem;
			padding: 0 .2rem;
			background-color: #FFFFFF;
			position: fixed;
			bottom: 0;
			left: 0;
			z-index: 9999;
		}
		
		.cart-handle .handle-delete {
			margin-left: .3rem;
			margin-top: -.05rem;
		}
		
		.cart-handle .total-price-box {
			justify-content: flex-end;
		}
		
		.cart-handle .total-box .text {
			font-size: .28rem;
			font-weight: 400;
			color: #333333;
		}
		
		.cart-handle .total-box .price {
			font-size: .4rem;
			font-weight: 600;
			color: #FC6B21;
		}
		
		.cart-handle .order-now-btn {
			width: 1.98rem;
			height: .76rem;
			background: linear-gradient(90deg, #3A69E9 0%, #3A95E9 100%);
			border-radius: .08rem;
			text-align: center;
			line-height: .76rem;
			font-size: .32rem;
			font-weight: 500;
			color: #FFFFFF;
			margin-left: .24rem;
		}
		
		/* 公共样式 */
		.c-small-text {
			font-size: .28rem;
			font-weight: 400;
			color: #696969;
		}
		
		.c-box-flex {
			display: flex;
			align-items: center;
		}
		
		.c-wid-124 {
			width: 124px;
			text-align: right;
		}
		
		.c-wid-flex {
			flex: 1;
		}
		
		.c-reduced-price span {
			padding: 1px 4px;
			border-radius: 4px;
			opacity: 0.8;
			border: 1px solid #3A69E9;
			font-size: 12px;
			font-weight: 400;
			color: #3A69E9;
		}
	}
	
	/* pc端 */
	@media screen and (min-width: 1029px) {
		.MyCart {
			background-color: #F6F6F6;
		}
		
		/* 暂无商品 */
		.nothing-box a {
			display: block;
			width: 162px;
			line-height: 40px;
			background: #2468F2;
			border-radius: 4px;
			font-size: 14px;
			color: #FFFFFF;
			letter-spacing: 0;
			margin-bottom: 93px;
			text-align: center;
		}

		/* 商品总和 */
		.cart-handle {
			padding: 20px 27px;
		}

		.cart-handle .goods-text {
			cursor: pointer;
		}

		.cart-handle .total-box {
			display: flex;
		}

		.cart-handle .total-box>span {
			font-size: 18px;
			font-weight: 400;
			color: #929292;
			margin-right: 18px;
		}

		.cart-handle .total-box .total-price .price {
			font-size: 24px;
			font-weight: 500;
			color: #EB5757;
			margin-bottom: 5px;
		}

		.cart-handle .order-now-btn {
			margin-left: 47px;
			width: 222px;
			height: 56px;
			background: #3A69E9;
			border-radius: 4px;
			opacity: 1;
			font-size: 22px;
			font-weight: 500;
			color: #FFFFFF;
			line-height: 56px;
			text-align: center;
			cursor: pointer;
		}

		/* 商品列表 */
		.goods-group-box {
			padding: 0 20px;
		}
		
		.goods-item-box {
			display: flex;
			border-bottom: 1px solid #EDEDED;
		}
		
		.group-box {
			display: flex;
			padding: 20px 0;
		}
		
		/* 多选框 */
		.goods-group-box .item-check{
			margin-right: 20px;
			margin-top: 71px;
		}
		
		/* 商品信息 */
		.goods-group-box .item-info {
			flex: 1;
		}

		/* 图片 */
		.img-box {
			display: block;
			width: 106px;
			height: 142px;
			margin-right: 14px;
		}

		.img-box img {
			width: 100%;
			height: 100%;
		}

		/* 商品信息--书名 */
		.price-box {
			margin-top: 3px;
		}

		.price-box .title {
			font-size: 16px;
			font-weight: 500;
			color: #3A3A3A;
		}
		
		.price-box .check-num {
			font-size: 14px;
			font-weight: 400;
			color: #3A3A3A;
		}

		.price-box .actual-price {
			font-size: 19px;
			font-weight: 600;
			color: #3A3A3A;
			display: flex;
			align-items: center;
			justify-content: flex-end;
		}
		
		.price-box .actual-price .text {
			font-size: 15px;
			font-weight: 400;
			margin-right: 6px;
		}
		
		.price-box .delete-txt {
			cursor: pointer;
		}

		/* 购买类型 */
		.buy-type-box {
			margin: 8px 0 17px;
		}

		.buy-type-box .buy-type {
			font-size: 16px;
			font-weight: 400;
			color: #929292;
		}

		/* 章节 */
		.chapter-box {
			position: relative;
		}

		.chapter-box .chapters {
			width: 100%;
			margin-bottom: 12px;
		}
		
		.chapter-box .chapters .check-box {
			margin-right: 12px;
		}

		.chapter-box .chapters .title {
			font-size: 14px;
			font-weight: 400;
			color: #3A3A3A;
		}

		.chapter-box .chapters .price {
			font-size: 16px;
			font-weight: 400;
			color: #656565;
		}
		
		.chapter-box .chapters .handle-btn {
			cursor: pointer;
		}

		.chapter-box .chapters .handle-btn span {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
		}
		
		.delete-txt {
			cursor: pointer;
		}

		/* 购物车text */
		.pc-cart-container {
			width: 1200px;
			margin: 14px auto;
			background: #FFFFFF;
			box-sizing: border-box;
		}

		.pc-cart-container .cart-count {
			font-size: 20px;
			font-weight: 600;
			color: #3A3A3A;
			padding: 20px;
		}

		.check-all-box {
			height: 48px;
			padding: 0 20px;
		}

		.all-checkbox .goods-text {
			margin-left: 26px;
		}

		/* 公共样式 */
		.c-small-text {
			font-size: 16px;
			font-weight: 400;
			color: #656565;
		}

		.c-box-flex {
			display: flex;
			align-items: center;
		}

		.c-wid-124 {
			width: 124px;
			text-align: right;
		}

		.c-wid-flex {
			flex: 1;
		}

		.c-reduced-price span {
			padding: 3px 4px;
			border-radius: 4px;
			opacity: 0.8;
			border: 1px solid #3A69E9;
			font-size: 12px;
			font-weight: 400;
			color: #3A69E9;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/MyCart/MyCart.vue